module.exports = __webpack_public_path__ + "static/media/computer.1ec52ad5.png";